import React from 'react';
import { EditDishRestaurantPropertiesState } from './editDishRestaurantPropertiesState/EditDishRestaurantPropertiesState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

export const EditDishRestaurantPropertiesPage: React.FC = () => {
	return (
		<EditDishRestaurantPropertiesState>
			<Forms />
			<ModalWindows />
		</EditDishRestaurantPropertiesState>
	);
};
